import React, { useEffect, useState } from 'react'
import FeatureCard from '../FeatureCard/FeatureCard'

function Categories() {
    const [categories, setCategories] = useState([])

    useEffect(() => {
        const fetchcategories = async () => {
            const res = await fetch("https://fakestoreapi.com/products/categories")
           // const res = await fetch("https://dummyjson.com/products/categories")
            const data = await res.json()
            console.log(data)
            setCategories(data)
        }
        fetchcategories()
    }, [])
  
    if(categories.length===0) return <div>

<div className="card" aria-hidden="true">
                        <img src="..." className="card-img-top" alt="..."/>
                        <div className="card-body">
                          <h5 className="card-title placeholder-glow">
                            <span className="placeholder col-6"></span>
                          </h5>
                          <p className="card-text placeholder-glow">
                            <span className="placeholder col-7"></span>
                            <span className="placeholder col-4"></span>
                            <span className="placeholder col-4"></span>
                            <span className="placeholder col-6"></span>
                            <span className="placeholder col-8"></span>
                          </p>
                          <a href="#" tabindex="-1" className="btn btn-primary disabled placeholder col-6"></a>
                        </div>
                      </div>
    </div>
    return (
    
      <FeatureCard cards={categories} />
     
    )
}

export default Categories
